<div class="spend-chart-placeholder">
  <ng-content></ng-content>
</div>
